import { render } from "./SimilarRecommendations.vue?vue&type=template&id=0580203a&scoped=true"
import script from "./SimilarRecommendations.vue?vue&type=script&lang=js"
export * from "./SimilarRecommendations.vue?vue&type=script&lang=js"

import "./SimilarRecommendations.vue?vue&type=style&index=0&id=0580203a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0580203a"]])

export default __exports__